exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fixedWidthText[data-v-794cc64a]{min-width:5.2em}", ""]);

// exports
